import {
  type ANCIEN_TYPE_EVAL_FAIRVIEW,
  TemplateEntStructEnum,
  TemplateFormEnum,
  TemplateInbasketEnum,
  TypeEvalEnum,
  typeEvalCourant,
} from "../../../convex/schema";

/**
 * Configuration d'une évaluation au sein d'une campagne
 */
export interface EvalConfig {
  typeEval: TypeEvalEnum;
  template?: TemplateFormEnum | TemplateInbasketEnum | TemplateEntStructEnum;
}

// RESULTATS = conteneur interne (§1.1), non sélectionnable admin. Présent ici
// uniquement pour l'exhaustivité de la map.
const TYPE_EVAL_LABELS: Record<TypeEvalEnum, string> = {
  [TypeEvalEnum.INBASKET]: "Inbasket",
  [TypeEvalEnum.FORM]: "Formulaire",
  [TypeEvalEnum.ENT_STRUCT]: "FairView",
  [TypeEvalEnum.RESULTATS]: "Résultats",
};

/**
 * Retourne le label d'un type d'évaluation
 */
export function getTypeEvalLabel(
  typeEval: TypeEvalEnum | typeof ANCIEN_TYPE_EVAL_FAIRVIEW,
): string {
  return TYPE_EVAL_LABELS[typeEvalCourant(typeEval)];
}
